/**
 * Created by Administrador on 06/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('transferPassengerCtrl', transferPassengerCtrl);

    transferPassengerCtrl.$inject = ['linkService','datePickerService','$timeout','transferPassengerService',
        'segmentFlightService','dialogService','$stateParams','airports','revenueProductionService','dateService', 'AuthServerProvider'];

    function transferPassengerCtrl(linkService,datePickerService,$timeout,transferPassengerService,segmentFlightService,
                                   dialogService,$stateParams,airports,revenueProductionService,dateService, AuthServerProvider){
        var vm = this;
        vm.linkService = linkService;

        /* Dates */
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.dateFormat = 'dd/MM/yyyy';

        vm.beforeYesterday = dateService.addDays(new Date(), -365);
        vm.beforeYesterday.setHours(0,0,0);

        vm.originDate = {
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.beforeYesterday
            }
        };

        vm.transferDate = {
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.beforeYesterday
            }
        };

        vm.dpOpenStatus = {
            'originDate': false,
            'transferDate': false
        };

        vm.openCalendar = function(date) {
            vm.dpOpenStatus[date] = true;
        };

        /* End dates */
        vm.userAccount = AuthServerProvider.getUserAccount();
        vm.airports = airports;

        vm.transferPassenger = {
            originDate: new Date(),
            transferDate: new Date(),
            originAvailableSeats: 0,
            transferAvailableSeats: 0,
            originSegmentFlight: {},
            transferSegmentFlight: {}
        };

        vm.eventChangeOriginDestiny = function(dateType){
            var origin = (dateType == 'originDate')?vm.transferPassenger.originAirport : vm.transferPassenger.originTransfer;
            var destiny = (dateType == 'originDate')?vm.transferPassenger.destinyAirport : vm.transferPassenger.destinyTransfer;
            var date = (dateType == 'originDate')?vm.transferPassenger.originDate : vm.transferPassenger.transferDate;
            if(origin == undefined || destiny == undefined){
                if(dateType=='originDate'){
                    vm.originStretches = [];
                    vm.originPnrs = [];
                }else{
                    vm.transferStretches = [];
                    vm.transferPnrs = [];
                }
            }else{
                $timeout(function(){
                    if (origin.iata == destiny.iata) {
                        dialogService.dialogError('air.transferPassenger.originAndDestinyMustBeDifferent');
                        if(dateType=='originDate'){
                            vm.transferPassenger.destinyAirport = undefined;
                        }else{
                            vm.transferPassenger.destinyTransfer = undefined;
                        }
                    }else{

                    }

                    segmentFlightService.getSegmentByOriginDestinyDate(vm.linkService.getLinkId(origin._links.self.href),vm.linkService.getLinkId(destiny._links.self.href),date.getTime())
                        .then(function (response) {
                            if(dateType == 'originDate'){
                                vm.originStretches = response;
                            }else if(dateType == 'transferDate'){
                                vm.transferStretches = response;
                            }
                        });

                }, 100);
            }
        }

        vm.eventChangeStretch = function(dateType){
            var stretch = (dateType == 'originDate') ? vm.transferPassenger.originStretch :
                vm.transferPassenger.transferStretch;
            if(stretch == undefined){
                if(dateType=='originDate'){
                    vm.originPnrs = [];
                }else{
                    vm.transferPnrs = [];
                }
            }else {
                if ((vm.transferPassenger.originStretch != undefined && vm.transferPassenger.transferStretch != undefined)
                     && (vm.transferPassenger.originStretch.segmentFlightId == vm.transferPassenger.transferStretch.segmentFlightId)) {
                    dialogService.dialogError('air.transferPassenger.notTransferToTheSameFlight');
                    vm.transferPassenger.transferStretch = undefined;
                    vm.transferPnrs = [];
                } else {
                    $timeout(function () {
                        if (dateType == 'originDate') {
                            vm.originPnrs = [];
                            revenueProductionService.getOverSoldAll(stretch.segmentFlightId)
                                .then(function (response) {
                                    vm.transferPassenger.originAvailableSeats =
                                        ((response.data.takeOffCapacity+response.data.overLoad)-response.data.occupied);
                                    vm.transferPassenger.originSegmentFlight = response.data;
                                });

                        } else if (dateType == 'transferDate') {
                            vm.transferPnrs = [];
                            revenueProductionService.getOverSoldAll(stretch.segmentFlightId)
                                .then(function (response) {
                                    vm.transferPassenger.transferAvailableSeats =
                                        ((response.data.takeOffCapacity+response.data.overLoad)-response.data.occupied);
                                    vm.transferPassenger.transferSegmentFlight = response.data;
                                });
                        }


                        transferPassengerService.getPNRs(stretch.segmentFlightId, $stateParams.page, $stateParams.size)
                            .then(function (response) {
                                if (dateType == 'originDate') {
                                    angular.forEach(response, function (pnr) {
                                        vm.originPnrs.push(pnr);
                                    });
                                    //vm.originPnrs = response;
                                } else if (dateType == 'transferDate') {
                                    //vm.transferPnrs = response;
                                    angular.forEach(response, function (pnr) {
                                        vm.transferPnrs.push(pnr);
                                    });
                                }
                            });

                        transferPassengerService.getCheckInPNRs(stretch.segmentFlightId, $stateParams.page, $stateParams.size)
                            .then(function (response) {
                                if (dateType == 'originDate') {
                                    angular.forEach(response, function (pnr) {
                                        pnr.status = 'CHECKED';
                                        vm.originPnrs.push(pnr);
                                    });
                                } else if (dateType == 'transferDate') {
                                    angular.forEach(response, function (pnr) {
                                        pnr.status = 'CHECKED';
                                        vm.transferPnrs.push(pnr);
                                    });
                                }
                            });
                    }, 100);
                }
            }
        }

        vm.saveTransferPassenger = function(isValid, pnrCode, dateType, code, status){
            if(isValid){
                if(vm.transferPassenger.originStretch.segmentFlightId == vm.transferPassenger.transferStretch.segmentFlightId){
                    dialogService.dialogError('air.transferPassenger.notTransferToTheSameFlight');
                    vm.transferPassenger.transferStretch = undefined;
                    vm.transferPnrs = [];
                }else{
                    transferPassengerService.getPNRById(pnrCode)
                        .then(function (response) {
                            response.observation = vm.transferPassenger.observation;
                            response.agent = null;

                            var newFlight = dateType=='originDate'? vm.transferPassenger.transferStretch :
                                vm.transferPassenger.originStretch;
                            var currentSegmentFlightId = dateType=='originDate'?
                                vm.transferPassenger.originStretch.segmentFlightId:
                                vm.transferPassenger.transferStretch.segmentFlightId;
                            var returned = true;

                            angular.forEach(response.flights, function(flight){
                                if(flight.segmentFlightId==currentSegmentFlightId){
                                    if(newFlight != undefined){
                                        flight.arrivalDatetime = newFlight.arrivalDatetime;
                                        flight.departureDatetime = newFlight.departureDatetime;
                                        flight.connections = newFlight.connections;
                                        flight.flightNumber = newFlight.flightNumber;
                                        flight.from = newFlight.from;
                                        flight.notstop = newFlight.notstop;
                                        flight.routeId = newFlight.routeId;
                                        flight.segmentFlightId = newFlight.segmentFlightId;
                                        flight.state = newFlight.state;
                                        flight.to = newFlight.to;
                                        flight.type = newFlight.type;
                                        returned = flight.returned;
                                    }
                                }
                            });
                            response.changeReturn = returned ? "RETURN" : "GOING";

                            angular.forEach(response.passengers, function(passenger){
                                angular.forEach(passenger.rti, function(rti) {
                                    if (rti.segmentFlightId == currentSegmentFlightId) {
                                        if (newFlight != undefined) {
                                            rti.flightNumber = newFlight.flightNumber;
                                            rti.segmentFlightId = newFlight.segmentFlightId;
                                            var rtiConnectionsAux = [];
                                            angular.forEach(newFlight.connections, function(connection) {
                                                var rtiConnectionAux = {
                                                    category: null,
                                                    departureFlightId: connection.id,
                                                    flightNumber: connection.flightNumber,
                                                    order: 0,
                                                    seatId: 0,
                                                    selectedSeat: "",
                                                    withInfant: false,
                                                    used: true
                                                }
                                                rtiConnectionsAux.push(rtiConnectionAux);

                                            });
                                            rti.lowPnrFlight = false;
                                            rti.interruption = false;
                                            rti.rtiConnections = rtiConnectionsAux;
                                            rti.selectedFare.segmentClassId = getSegmentClassId(rti.selectedFare.classId,dateType);
                                        }
                                    }
                                });


                            });
                            var operationSale = {
                                typeOperation: "TRANSFER_PASSENGER",
                                origin: null,
                                pnrCode: code,
                                split: false,
                                change: response
                            };

                            transferPassengerService.updateChangeFlightPnr(operationSale, vm.userAccount.userName,status)
                                .then(function(response1){
                                    if(response1!=undefined && response1=='ok'){
                                        if(status=='CHECKED') {
                                            var oldSegmentFlightId = 0;
                                            var newSegmentFlightId = 0;

                                            if(dateType=='originDate'){
                                                oldSegmentFlightId = vm.transferPassenger.originStretch.segmentFlightId;
                                                newSegmentFlightId = vm.transferPassenger.transferStretch.segmentFlightId;
                                            }else{
                                                oldSegmentFlightId = vm.transferPassenger.transferStretch.segmentFlightId;
                                                newSegmentFlightId = vm.transferPassenger.originStretch.segmentFlightId;
                                            }

                                            transferPassengerService.updateTransferLuggage(code, oldSegmentFlightId, newSegmentFlightId, vm.userAccount.userName)
                                                .then(function (response) {
                                                    vm.eventChangeStretch('originDate');
                                                    vm.eventChangeStretch('transferDate');
                                                });
                                        }else{
                                            vm.eventChangeStretch('originDate');
                                            vm.eventChangeStretch('transferDate');
                                        }

                                    }
                                });

                            /*segmentFlightService.getSegmentFlight(stretch.segmentFlightId)
                                .then(function (response) {
                                    vm.transferPassenger.originAvailableSeats =
                                        ((response.data.takeOffCapacity+response.data.overLoad)-response.data.occupied);
                                });*/
                        });
                }
            }else{
                if(vm.transferPassenger.originFlight == undefined){
                    dialogService.dialogRequiredError('air.transferPassenger.table.originFlight');
                    vm.transferPassenger.originFlight = undefined;
                }else if(vm.transferPassenger.originStretch == undefined){
                    dialogService.dialogRequiredError('air.transferPassenger.table.originStretch');
                    vm.transferPassenger.originStretch = undefined;
                }else if(vm.transferPassenger.transferFlight == undefined){
                    dialogService.dialogRequiredError('air.transferPassenger.table.transferFlight');
                    vm.transferPassenger.transferFlight = undefined;
                }else if(vm.transferPassenger.transferStretch == undefined){
                    dialogService.dialogRequiredError('air.transferPassenger.table.transferStretch');
                    vm.transferPassenger.transferStretch = undefined;
                }
            }
        }

        function getSegmentClassId(classId, dataType){
            var res = 0;
            var segmentClasses = dataType==='originDate'?
                    vm.transferPassenger.transferSegmentFlight._embedded.segmentClasses:
                    vm.transferPassenger.originSegmentFlight._embedded.segmentClasses;
            for(var i=0; i<segmentClasses.length; i++){
                if(segmentClasses[i].classId === classId){
                    res = vm.linkService.getLinkId(segmentClasses[i]._links.self.href);
                    break;
                }
            }
            return res;
        }
    }
})();
